import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@dagensmat/carrot/Components';
import PageHeader from '@components/page-header/PageHeader';
import EditDeliveryInformationRedirector from '_common/pages/deliveryInformation/EditDeliveryInformationRedirector';
import { DeliveryWindow } from '../../../types/Consumer';
import { Illustrations } from '../../../utils/Illustrations';
import { Page } from '@components/page';
import { Container } from '@dagensmat/carrot/Layout';
import { CommonNavbar } from '@components/navbar';

type OrderConfirmationProps = {
  headerText: string;
  subTitle: string;
  deliveryAddress?: string;
  deliveryWindow?: DeliveryWindow;
  deliveryInfo?: string;
  deliveryDateCount: number;
};

const OrderConfirmation = ({
  headerText,
  subTitle,
  deliveryAddress,
  deliveryWindow,
  deliveryInfo,
  deliveryDateCount
}: OrderConfirmationProps) => {
  const { t } = useTranslation();

  const deliveryCountRef = React.useRef(deliveryDateCount);

  return (
    <Page header={<CommonNavbar showLogo />}>
      <PageHeader headerText={headerText} />
      <Typography variant="paragraph" mb="l">
        {subTitle}
      </Typography>
      <Typography variant="paragraphSmall" color="secondary" mb="s">
        {t('consumer:YourOrderWillBeDeliveredTo', {
          count: deliveryCountRef.current || 1
        })}
      </Typography>
      <EditDeliveryInformationRedirector
        deliveryAddress={deliveryAddress}
        deliveryWindow={deliveryWindow}
        deliveryInfo={deliveryInfo}
        redirectTo="/orders"
        showHeader={false}
      />
      <Container flex justify="end">
        <img
          alt="Illustrasjon av bestillingsbekreftelse med masse godt i kassen"
          style={{
            height: 'auto',
            maxWidth: '360px',
            width: '100%',
            display: 'block',
            margin: '20px 0'
          }}
          src={Illustrations.CUSTOMER_CARRYING_ONION_GREEN}
        />
      </Container>
    </Page>
  );
};

export default OrderConfirmation;
